import { IRootState } from '../../../../store'
import { IImmobilizationState } from '../store/immobilization.types'

export const getImmobilizationSelector = (state: IRootState): IImmobilizationState => state.immobilization
